import EfFaqCollapse, { EfFaqCollapseItemProps, EfFaqCollapseProps } from '@elem/ui/ef-faq-collapse';
import EfSpec from '@elem/ui/ef-spec';
import styles from './index.module.scss';
import { useLang } from '@/i18n';

const tag = 'EcoFlow App';

export default function TheComp() {
    const { t } = useLang('delta3series');

    const specPic = 'https://websiteoss.ecoflow.com/upload/image/1733144046752/EU-intput.jpg';

    const configs: EfFaqCollapseProps = {
        label: t('I_label'),
        title: t('I_title'),
        type: 'img',
        lists: [
            {
                img: [
                    {
                        pc: 'https://websiteoss.ecoflow.com/upload/image/1724677776818/a1.jpg',
                        imgTitle: t('I_item1_img1'),
                    },
                    {
                        pc: 'https://websiteoss.ecoflow.com/upload/image/1724677776985/a2.jpg',
                        imgTitle: t('I_item1_img2'),
                    },
                ],
                title: t('I_item1_title'),
                desc: t.rich('I_item1_desc', {
                    y: (tx: string) => <span className="y">{tx}</span>,
                }),
                tag,
            },
            {
                img: specPic,
                title: t('I_item2_title'),
                desc: t.rich('I_item2_desc', {
                    y: (tx: string) => <span className="y">{tx}</span>,
                }),
                tag,
            },
            {
                img: 'https://websiteoss.ecoflow.com/upload/image/1724662064367/a4.jpg',
                title: t('I_item3_title'),
                desc: t.rich('I_item3_desc', {
                    y: (tx: string) => <span className="y">{tx}</span>,
                }),
                tag,
            },
            {
                img: 'https://websiteoss.ecoflow.com/upload/image/1724662064804/a5.jpg',
                title: t('I_item4_title'),
                desc: t.rich('I_item4_desc', {
                    y: (tx: string) => <span className="y">{tx}</span>,
                }),
                tag,
            },
        ] as EfFaqCollapseItemProps[],
    };

    return (
        <div className={`${styles.TheComp} GtmModuleData-section range9`} data-section-id="D3-I" id='D3-I'>
            <EfSpec className="spec-x" />
            <EfFaqCollapse {...configs} />
        </div>
    );
}
